<ng-container rtBlock="sc-app-footer">
    <div rtElem="inner">
        <div rtElem="col" [rtMod]="{ brand: true }">
            <div rtElem="logo">GoldenCalc</div>
            <p rtElem="tagline" i18n="@@appFooterTagline">
                Онлайн-конструктор деревянных лестниц. Расчёт и визуализация — в браузере, без установки ПО.
            </p>
            <div rtElem="domains">
                <a
                    rtElem="domain"
                    qa-dataid="footer-domain"
                    data-domain="by"
                    href="https://goldencalc.by/"
                    rel="alternate"
                    hreflang="ru-BY">
                    goldencalc.by
                </a>
                <span aria-hidden="true">·</span>
                <a
                    rtElem="domain"
                    qa-dataid="footer-domain"
                    data-domain="ru"
                    href="https://goldencalc.ru/"
                    rel="alternate"
                    hreflang="ru-RU">
                    goldencalc.ru
                </a>
                <span aria-hidden="true">·</span>
                <a rtElem="domain" qa-dataid="footer-domain" data-domain="com" href="https://goldencalc.com/" rel="alternate" hreflang="en">
                    goldencalc.com
                </a>
            </div>
        </div>

        <div rtElem="col">
            <h2 rtElem="title" i18n="@@appFooterColCalc">Калькуляторы</h2>
            <ul rtElem="links">
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="calc-straight"
                        routerLink="/calc/straight"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@homeTypeTitleStraight">
                        Прямая
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="calc-l"
                        routerLink="/calc/l"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@homeTypeTitleL">
                        Г-образная
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="calc-u"
                        routerLink="/calc/u"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@homeTypeTitleU">
                        П-образная
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="calc-spiral"
                        routerLink="/calc/spiral"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@homeTypeTitleSpiral">
                        Винтовая
                    </a>
                </li>
            </ul>
        </div>

        <div rtElem="col">
            <h2 rtElem="title" i18n="@@appFooterColProject">Проект</h2>
            <ul rtElem="links">
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="about"
                        routerLink="/about"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@navAbout"
                        [routerLinkActiveOptions]="{ exact: true }">
                        О проекте
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="catalog"
                        routerLink="/catalog"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@breadcrumbCatalog">
                        Каталог
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="contacts"
                        routerLink="/contacts"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@appFooterContacts">
                        Контакты
                    </a>
                </li>
            </ul>
        </div>

        <div rtElem="col">
            <h2 rtElem="title" i18n="@@appFooterColLegal">Правовое</h2>
            <ul rtElem="links">
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="privacy"
                        routerLink="/privacy"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@appFooterPrivacy">
                        Политика
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="terms"
                        routerLink="/terms"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@appFooterTerms">
                        Соглашение
                    </a>
                </li>
                <li>
                    <a
                        qa-dataid="footer-link"
                        data-link="cookies"
                        routerLink="/cookies"
                        routerLinkActive="sc-app-footer__link--active"
                        i18n="@@appFooterCookies">
                        Cookies
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div rtElem="bottom">
        <span>
            © {{ currentYear() }}
            <span i18n="@@appFooterCopyrightSuffix">GoldenCalc. Инструмент бесплатный, AS-IS.</span>
        </span>
        <span>v{{ appVersion }}</span>
    </div>
</ng-container>
